export default __webpack_public_path__ + "static/media/LogoHseqtechcl.253fedf8.png";